import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Subscription, throwError } from 'rxjs';
import { catchError, filter, finalize } from 'rxjs/operators';
import { UserProfile, ValidationService } from '../../core';

import { CommonService } from '../../core/services/common.service';
import { GiftShareValidators } from '../../shared';
import { Store } from '@ngxs/store';

@Component({
    selector: 'gs-support',
    templateUrl: './support.component.html',
    standalone: false
})
export class SupportComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  form: FormGroup;
  hasMessageBeenSent: boolean = false;
  error: string;

  contactOptions = [
    { id: null, name: 'Selecteaza subiect' },
    { id: 1, name: 'Informatii generale' },
    { id: 2, name: 'Vreau sa fiu partener' },
    { id: 3, name: 'Corporate' },
    { id: 4, name: 'Legal' }
  ];

  constructor(
    private commonContactService: CommonService,
    private route: ActivatedRoute,
    private ngxUiLoaderService: NgxUiLoaderService,
    private store: Store,
    private formBuilder: FormBuilder,
    public vs: ValidationService
  ) {
    this.form = this.formBuilder.group({
      name: [null, [Validators.required, Validators.maxLength(100)]],
      email: [null, [Validators.required, GiftShareValidators.email, Validators.maxLength(256)]],
      phone: [null, [Validators.maxLength(256)]],
      subject: [null, [Validators.required]],
      message: [null, [Validators.required]],
    });
  }

  ngOnInit() {
    this.subscriptions.push(
      this.route.queryParamMap.subscribe(queryParams => {
        if (queryParams.has('subject')) {
          const querySubject = +queryParams.get('subject');
          if (this.contactOptions.find(o => o.id === querySubject)) {
            this.form.patchValue({
              subject: querySubject
            });
          }
        }
      }),

      this.store.select<UserProfile>(state => state.auth.user)
        .pipe(filter(x => !!x))
        .subscribe(user => {
          this.form.patchValue({
            name: user.name,
            email: user.email,
            phone: user.phone,
          });
        })
    );
  }

  onSubmit() {
    this.error = null;
    this.hasMessageBeenSent = false;

    if (!this.form.valid) {
      this.vs.triggerValidation(this.form);
      return;
    }

    const model = {
      ...this.form.value,
      subject: this.contactOptions.find(item => item.id == this.form.value.subject).name
    };

    this.ngxUiLoaderService.start();
    this.subscriptions.push(
      this.commonContactService.sendEmail(model)
        .pipe(
          catchError(e => {
            this.error = e.error?.detail || e.error?.title || 'A aparut o problema neasteptata. Echipa noastra lucreaza pentru a o remedia.';
            return throwError(e);
          }),
          finalize(() => {
            this.ngxUiLoaderService.stop();
          })
        )
        .subscribe(() => {
          this.hasMessageBeenSent = true;
          // this.form.disable();
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
